import { useCallback, useRef } from 'react';

// Module-level cache to persist animation state across component mounts/unmounts
const animationCache = new Map<string, boolean>();

const generateCacheKey = (strings: string[], fixedText?: string) => {
  return `${fixedText || ''}-${strings.join('|')}`;
};

type UseAnimationCacheOptions = {
  enabled: boolean;
  fixedText?: string;
  strings: string[];
};

export const useAnimationCache = ({ enabled, fixedText, strings }: UseAnimationCacheOptions) => {
  const cacheKey = useRef(generateCacheKey(strings, fixedText)).current;
  const hasPlayed = enabled ? animationCache.get(cacheKey) ?? false : false;

  const markAsPlayed = useCallback(() => {
    if (enabled) {
      animationCache.set(cacheKey, true);
    }
  }, [enabled, cacheKey]);

  return {
    cacheKey,
    hasPlayed,
    markAsPlayed,
  };
};
